<app-analytics-report-popup
    [report]="selectedRerport"
></app-analytics-report-popup>
<ni-card bgColor="main">
    <div class="row mt-3">
        <div class="col-md-6 col-xl-3">
            <app-statistics-total-customers
                [endDate]="filterEndDate"
                [startDate]="filterStartDate"
            ></app-statistics-total-customers>
        </div>

        <div class="col-md-6 col-xl-3">
            <app-statistics-total-aircraft
                [endDate]="filterEndDate"
                [startDate]="filterStartDate"
            ></app-statistics-total-aircraft>
        </div>

        <div class="col-md-6 col-xl-3">
            <app-statistics-total-orders
                [endDate]="filterEndDate"
                [startDate]="filterStartDate"
            ></app-statistics-total-orders>
        </div>

        <div class="col-md-6 col-xl-3">
            <app-statistics-orders-by-location
                [endDate]="filterEndDate"
                [startDate]="filterStartDate"
            ></app-statistics-orders-by-location>
        </div>
    </div>
    <section class="row">
        <div class="col-12">
            <app-analytics-activity-reports
                (reportClicked)="openReport($event)"
            ></app-analytics-activity-reports>
        </div>
    </section>
    <div class="row widget-drop-list"
         cdkDropList
         [cdkDropListData]="widgets"
         (cdkDropListDropped)="onWidgetDrop($event)">
        <ng-container *ngFor="let widget of widgets">
            <div cdkDrag
                 [class]="widget.colClass + ' widget-drag-item'">
                <div class="widget-drag-placeholder" *cdkDragPlaceholder></div>
                <div class="widget-drag-handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                </div>
                <ng-container [ngSwitch]="widget.id">
                    <app-analytics-fuel-vendor-source *ngSwitchCase="'fuel-vendor-sources'"></app-analytics-fuel-vendor-source>
                    <app-analytics-market-share-fbo-airport *ngSwitchCase="'market-share'"></app-analytics-market-share-fbo-airport>
                    <app-analytics-orders-quote *ngSwitchCase="'quotes-orders-won'"></app-analytics-orders-quote>
                    <app-analytics-orders-over-time *ngSwitchCase="'monthly-fuel-orders'"></app-analytics-orders-over-time>
                    <app-analytics-customer-breakdown *ngSwitchCase="'top-customers'"></app-analytics-customer-breakdown>
                    <app-analytics-volumes-nearby-airport *ngSwitchCase="'volumes-nearby'"></app-analytics-volumes-nearby-airport>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ni-card>
